import React from "react";
import "./MethodologyTab.css";

export default function MethodologyTab({ creator }) {
  if (!creator) return null;

  return (
    <section className="research-process">
      <h2>CY Score Calculation</h2>
      <p>For <strong>{creator.creator_name}</strong>, here’s how the CY score was computed:</p>

      <div className="metrics-grid">
        <MetricCard label="Momentum" value={creator.momentum} description="Views relative to followers — traction strength." />
        <MetricCard label="Virality" value={creator.virality} description="Likes relative to views — breakout potential." />
        <MetricCard label="Consistency" value={creator.consistency} description="Posting regularity compared to ideal schedule." />
        <MetricCard label="Velocity" value={creator.velocity} description="Follower base vs posting frequency — growth speed." />
        <MetricCard label="Brand Safety" value={creator.brand_safety} description="Baseline suitability for advertisers." />
      </div>
      <section className="inputs-grid">
        <MetricCard label="Followers" value={creator.followers?.toLocaleString()} description="Total audience size." />
        <MetricCard label="Avg Views" value={creator.avg_views?.toLocaleString()} description="Average views per video." />
        <MetricCard label="Avg Likes" value={creator.avg_likes?.toLocaleString()} description="Average likes per video." />
        <MetricCard label="Posting Frequency" value={`${creator.posting_frequency}/week`} description="Content output rate." />
        </section>

      <div className="cy-score-box">
        <h3>CY Score</h3>
        <p className="score">{creator.cy_score}/100</p>
      </div>

      <p><strong>Last analyzed:</strong> {new Date(creator.analyzed_at).toLocaleDateString()}</p>
    </section>

    
  );


}

function MetricCard({ label, value, description }) {
  return (
    <div className="metric-card">
      <h4>{label}</h4>
      <p>{value}</p>
      <small>{description}</small>
    </div>
  );
}
